/**
 * Created by d.penning on 04.10.2017.
 */
import { createStore, applyMiddleware } from 'redux'
import logger from 'redux-logger'
import rootReducer from '../reducers/rootReducer'
import piwikMiddleware from "../middleware/piwikMiddleware";
import pollerMiddleware from '../middleware/pollerMiddleware';
import initializerMiddleware from '../middleware/initializerMiddleware';
import matchFeedsMiddleware from '../middleware/matchFeedsMiddleware';
import { IState } from './state';
import customerIntegrationMiddleware from '../middleware/customerIntegrationMiddleware';
import timingsMiddleware from '../middleware/timingsMiddleware';
import loggerMiddleware from '../middleware/loggerMiddleware';
import resizeMiddleware from '../middleware/resizeMiddleware';
import carouselMiddleware from '../middleware/carouselMiddleware';
import focusMatchMiddleware from '../middleware/focusMatchMiddleware'; // TODO: this should be conditional imported only on preloadedState.config.focusmatchid
import { Middleware } from 'redux';

const storeConfig = (preloadedState?: any) => {
    let middleware:Middleware[] = [
        //loggerMiddleware, // must be the first one
        carouselMiddleware,
        customerIntegrationMiddleware,
        initializerMiddleware,
        matchFeedsMiddleware,
        piwikMiddleware,
        pollerMiddleware,
        resizeMiddleware,
        timingsMiddleware
    ]
    // apply focusMatchMiddleware only on demand (if focusmatchid is set)
    if(preloadedState.config.focusmatchid) {
        middleware.push(focusMatchMiddleware)
    }
    return createStore(
        rootReducer,
        preloadedState,
        applyMiddleware(...middleware)
    )
}

const configureStore = (preloadedState?: IState) => {
    const store = storeConfig(preloadedState);
    (window as any).store = store;
    return store
}

export default configureStore
